import { ListView } from './../../../../framework/tools/scrollview/listview';
import ChatItem from "./chatItem";
import { Notify } from '../../server/notify/proto_notify';
import ChatInfo from '../../../table/module/tablechat/chatinfo';
import Chat from './chat';
import ChatView, { ChatType } from './chat_view';
import ModelData from '../../../public/model_data';

// Learn TypeScript:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/typescript.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/reference/attributes.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/life-cycle-callbacks.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/life-cycle-callbacks.html

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChatScroll extends cc.Component {


    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    chatNode: cc.Node = null;

    chatview: ChatView = null
    //chatItems: ChatItem[] = []
    //data: any[] = []  //所有聊天数据
    totalCount = 0  //总共有多少条记录
    spawnCount = 0  //总循环个数
    upMaxPosY = 1200  //上限Y轴距离
    downMaxPosY = -1000 //下限Y轴距离
    contentLastPos = 0  //记录上次滑动位置
    scrollPos = 0;
    isStartCheck: boolean = false //是否开始检查滑动
    itemOffset = 10  //间距

    contentWidth = 710
    chatWorldData: Notify.GroupChatMessage.IGroupChatContent[] = []
    allFriendChatData: Notify.ChatMessage[] = []
    curChatFrientData: Notify.ChatMessage[] = []
    systemData: string[] = []


    startPos = 0
    endPos = 0
    isScrollUp = 0 // 0初始化 -1down 1up
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start() {

    }
    setParntent(parnetChat: ChatView) {
        this.chatview = parnetChat
    }
    initialize() {
        let index = 0
        let item = null
        let chatItem = null
        for (let i = 0; i < this.spawnCount; i++) {
            index = this.getInitIndex(i)

            item = this.instantiateObj(this.chatNode)
            // posY=this.getNewPosY()

            chatItem = item.getComponent(ChatItem);
            let itemData = this.getItemData(index)
            chatItem.setData(this.chatview.curChatType, index, itemData)
            item.parent = this.content
        }
        this.isScrollUp = 0
        this.isStartCheck = true
        this.checkAutoScroll()
    }


    getOhterPlayerId(sendId, revId) {

        let playerId = 0
        if (ModelData.instance.roleData.id == sendId) {
            playerId = revId
        }
        else {
            playerId = sendId
        }
        return playerId
    }


    getInitIndex(i) {
        if (this.chatview.curChatType == ChatType.worldChat) {
            if (this.chatWorldData.length > this.spawnCount) {
                return this.chatWorldData.length - this.spawnCount + i
            }

        }
        else if (this.chatview.curChatType == ChatType.friendChat) {
            if (this.curChatFrientData.length > this.spawnCount) {
                return this.curChatFrientData.length - this.spawnCount + i
            }
        }
        else if (this.chatview.curChatType == ChatType.system) {
            if (this.systemData.length > this.spawnCount) {
                return this.systemData.length - this.spawnCount + i
            }
        }
        return i
    }
    setInitData(len: number) {

        this.content.destroyAllChildren()
        this.content.removeAllChildren()



        this.totalCount = len
        this.spawnCount = this.totalCount >= 15 ? 15 : this.totalCount;


        this.initialize();
    }


    instantiateObj(prefabNode: cc.Node): cc.Node {
        var node = cc.instantiate(prefabNode)
        node.position = cc.v2(0, 0)
        node.scale = 1

        return node
    }
    scrollEvet(event: any) {
        if (!this.isStartCheck) {
            return
        }
        if (this.contentLastPos > this.content.position.y) {
            if (this.isScrollUp == 0 || this.isScrollUp == 1) {
                //cc.log("重新赋值 现在向下")
                this.isScrollUp = -1
                this.startPos = this.content.y
            }
            this.checkDwonItem()
        }
        else {
            if (this.isScrollUp == 0 || this.isScrollUp == -1) {
                //cc.log("重新赋值 现在向上")
                this.isScrollUp = 1
                this.startPos = this.content.y
            }
            this.checkUpItem()
        }
        this.contentLastPos = this.content.position.y
    }
    checkUpItem() { //手指向上滑
        if (this.content.childrenCount == 0) {
            return
        }
        this.endPos = this.content.y
        // if(!this.checkPos())
        // {
        //     return
        // }
        let tempPos = this.getPositionInView(this.content.children[0])
        if (tempPos.y > this.upMaxPosY) {

            let item = this.content.children[0].getComponent(ChatItem)
            let index = item.index
            index += this.spawnCount
            let arrLen = 0
            if (this.chatview.curChatType == ChatType.friendChat)//私聊
            {
                arrLen = this.curChatFrientData.length
            }
            else if (this.chatview.curChatType == ChatType.worldChat) //世界
            {
                arrLen = this.chatWorldData.length
            }
            else //系统
            {
                //arrLen=this.chatFriendData.length
            }
            if (index < arrLen) {
                let itemData = this.getItemData(index)
                item.setData(this.chatview.curChatType, index, itemData)
                this.content.insertChild(this.content.children[0], this.content.childrenCount)
                this.startPos = this.content.y
            }

        }


    }
    checkDwonItem() {//手指向下滑
        if (this.content.childrenCount <= 0) {
            return
        }
        this.endPos = this.content.y
        if (!this.checkPos()) {
            return
        }
        let startNode = this.content.children[0]
        let endNode = this.content.children[this.content.childrenCount - 1]
        let pos = this.getPositionInView(endNode)

        //if (pos.y < this.downMaxPosY ) 
        {
            let index = startNode.getComponent(ChatItem).index
            if (index - 1 >= 0) {
                let chatItem = endNode.getComponent(ChatItem)
                let itemData = this.getItemData(index - 1)
                cc.log("=========================================")
                cc.log(endNode.height + "xxxxxxx")
                chatItem.setData(this.chatview.curChatType, index - 1, itemData)
                cc.log(endNode.height + "yyyyyyy")
                cc.log(this.content.y + "aaaaaaaaa")

                this.content.insertChild(endNode, 0)
                cc.log(this.content.y + "bbbbb")
                this.startPos = this.content.y
                cc.log("=========================================")
            }
        }
    }
    checkPos() {
        let dis = Math.abs(this.endPos - this.startPos)
        if (dis > 20) {
            return true
        }
        else {
            return false
        }
    }
    getPositionInView(item) {
        let worldPos = item.parent.convertToWorldSpaceAR(item.position);
        let viewPos = this.scrollView.node.convertToNodeSpaceAR(worldPos);
        return viewPos;
    }

    addWordItem(chatMsgList: Notify.GroupChatMessage.IGroupChatContent[]) {
        for (let i = 0; i < chatMsgList.length; i++) {
            this.checkAddItem(i, chatMsgList[i])
        }
    }
    addFriendChatItem(chatMsg: Notify.ChatMessage) {
        this.checkAddItem(this.content.childrenCount, chatMsg)
    }
    addSystemItem(str: string) {
        this.checkAddItem(this.content.childrenCount, str)
    }
    checkAutoScroll() {
        let layout = this.content.getComponent(cc.Layout)
        layout.updateLayout()
        let maxHeight = 0
        if (this.chatview.curChatType == ChatType.friendChat) {
            maxHeight = 800
        }
        else if (this.chatview.curChatType == ChatType.worldChat) {
            maxHeight = 850
        }
        if (this.content.height > maxHeight) {
            this.scheduleOnce(() => {
                this.getComponent(cc.ScrollView).scrollToBottom()
                this.contentLastPos = this.content.position.y
                this.scrollPos = this.contentLastPos
            }, 0.2);
        }
    }



    // getNewPosY()
    // {
    //     let posY=0
    //     for(let i=0;i<this.content.childrenCount;i++)
    //     {
    //         let item=this.content.children[i].getComponent(ChatItem)

    //         posY+=item.getNodeHeight()           
    //     }

    //     return posY
    // }
    getItemData(index: number) {
        if (this.chatview.curChatType == ChatType.friendChat) //私聊
        {
            if (this.allFriendChatData.length > index) {
                return this.allFriendChatData[index]
            }
            else {
                return null
            }
        }
        else if (this.chatview.curChatType == ChatType.worldChat) //世界
        {
            if (this.chatWorldData.length > index) {
                return this.chatWorldData[index]
            }
            else {
                return null
            }

        }
        else //系统
        {
            if (this.systemData.length > index) {
                return this.systemData[index]
            }
            else {
                return null
            }
        }
    }
    checkAddItem(index, data: any) {
        let item: cc.Node = null
        let itemData = null
        let chatItem: ChatItem = null
        if (this.chatview.curChatType == ChatType.worldChat) {
            itemData = <Notify.GroupChatMessage.GroupChatContent>data
        }
        else if (this.chatview.curChatType == ChatType.friendChat) {
            itemData = <Notify.ChatMessage>data
        }
        else if (this.chatview.curChatType == ChatType.system) {
            itemData = <string>data
        }
        if (itemData == null) {
            cc.log("当前状态不可添加")
        }
        if (this.content.childrenCount < this.spawnCount || this.spawnCount == 0) {
            item = this.instantiateObj(this.chatNode)
            chatItem = item.getComponent(ChatItem)
            chatItem.setData(this.chatview.curChatType, index, itemData)
            item.parent = this.content
        }
        else {
            item = this.content.children[0]
            chatItem = item.getComponent(ChatItem)
            chatItem.setData(this.chatview.curChatType, index, itemData)
            this.content.insertChild(item, this.content.childrenCount)
        }
        this.checkAutoScroll()
    }
}
